











import { Component, Vue } from 'vue-property-decorator';
import { DxScrollView } from 'devextreme-vue';
import { DxPopup } from 'devextreme-vue/popup';

@Component({
    components: {
        DxPopup,
        DxScrollView,
    },
})
export default class InternalNotesLookupDialog extends Vue {
    public show: boolean = false;
    public internalNotesText: string = '';
    public title: string = '';

    public hide() {
        this.show = false;
    }
}
